import { getStatusColor, startCase } from '@/utils';
import { PriorityHigh as PriorityHighIcon } from '@mui/icons-material';
import {
  Avatar,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Tooltip,
} from '@mui/material';

export function IncidentListItem({ item: { size, start }, feature, ...props }) {
  const primary = feature.properties.description;
  const secondary = feature.properties.type?.name;

  return (
    <ListItemButton
      {...props}
      dense
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: `${size}px`,
        transform: `translateY(${start}px)`,
      }}
      // component={Link}
      // to={'.'}
    >
      <ListItemAvatar>
        <Tooltip title={startCase(feature.properties?.status)} placement="top">
          <Avatar
            sx={{
              bgcolor: getStatusColor(feature.properties?.status),
            }}
          >
            {feature.properties?.grade || <PriorityHighIcon />}
          </Avatar>
        </Tooltip>
      </ListItemAvatar>
      <ListItemText
        primary={primary}
        primaryTypographyProps={{ noWrap: true }}
        secondary={secondary}
        secondaryTypographyProps={{ noWrap: true }}
      />
    </ListItemButton>
  );
}
